function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { CloseButton } from "../common/close-button/CloseButton";
import "../cdn.scss";
import "./card.scss";
export const Card = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    title,
    tag = "h2",
    text = "",
    submit = false,
    onClick = () => null,
    bg = "cyan-20",
    href = "",
    target = "",
    icon,
    small = false,
    className = "",
    closeable,
    titleSize = "fs-h3"
  } = _ref;
  const HeaderTag = tag;
  const CardTag = href ? "a" : "div";
  const {
    onClose,
    ariaLabelText
  } = closeable || {};
  titleSize = small ? "fs-h4" : titleSize;
  const extraProps = {};
  if (!!href) {
    extraProps["href"] = href;
    if (!!target) {
      extraProps["target"] = target;
    }
  } else if (submit === true) {
    extraProps["type"] = "submit";
  }
  const iconColor = !["teal", "cyan"].some(color => bg.includes(color)) && "black-80";
  return /*#__PURE__*/React.createElement(CardTag, _extends({}, extraProps, {
    className: ["card", small && "card-sm", href && "card-link", "bg-".concat(bg), ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref,
    onClick: onClick
  }), onClose && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose,
    ariaLabel: ariaLabelText,
    iconColor: iconColor || undefined,
    className: "ml-auto"
  }), /*#__PURE__*/React.createElement("div", {
    className: "card-content"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "card-title flex"
  }, icon && /*#__PURE__*/React.createElement("i", {
    className: "fa-regular ".concat(icon, " mr-4 ").concat(iconColor ? "text-".concat(iconColor) : "")
  }), /*#__PURE__*/React.createElement(HeaderTag, {
    className: titleSize
  }, title)), typeof text === 'string' ? /*#__PURE__*/React.createElement("p", {
    className: "mt-3"
  }, text) : text), href && /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-chevron-right"
  }));
});